(function () {
    "use strict";

    var ReportParameterControl = Solovis.defineClass(
        "Solovis.Reports.Parameters.ReportParameterControl",
        Solovis.UI.BaseControl,
        function (options) {
            this.settings = options.settings ? options.settings : {};
            this.filter = this.settings.filter ? this.settings.filter : {};

            this.initialParameterValue = (typeof options.initialValue != "undefined") ? options.initialValue : false;
            this.currentReport = this.initialParameterValue;
        });

    ReportParameterControl.preload = function (newValue, callback) {        
        if (newValue && (newValue.id || newValue.code)) {
            var loadOptions: any = { report: {} };
            if (newValue.id)
                loadOptions.report.id = newValue.id;
            if (newValue.code)
                loadOptions.report.code = newValue.code;

            Solovis.Reports.ReportDataLoader.loadDataSetAsync("/Solovis/Metadata/ParameterLoad",
                loadOptions,
                function (response, success) {
                    if (success) {
                        var dataSet = response.result.dataSet;
                        var reportData = dataSet.report ? dataSet.report : null;
                        callback(reportData, true);
                    }
                    else {
                        callback(null, false);
                    }
                });
        }
        else {
            callback(null, true);
        }
    };

    ReportParameterControl.shouldPreload = function (value) {
        if (!value || (value.id && value.resourceId && value.label)) {
            // Already loaded.
            return false;
        }

        return true;
    };

    ReportParameterControl.serializeParameterValue = function (value) {
        if (value) {
            if (value.id) {
                return { id: value.id };
            }
        }

        return null;
    };

    ReportParameterControl.getLabel = function (value): string | undefined {
        return value?.path;
    }


    ReportParameterControl.prototype.doInit = function () {
    };

    ReportParameterControl.prototype.doRender = function () {
        var self = this;

        this.selectedReportLabel = $("<span>").appendTo(this.container);
        this.selectReportLink = $("<a>").html("<span class='fa fa-pencil'></span>").appendTo(this.container);

        this.selectReportLink.click(function () {
            Solovis.InvDataSelectors.ReportSelectorDialog.selectReport(function (report) {                
                self._setCurrentReportData(report);
                self.notifyParameterValueChanged();
            },
            { showClearButton: true });
        });

        // Set initial parameter value text.
        if (this.currentReport) {
            this._setCurrentReportData(this.currentReport);
        }

        Solovis.Site.DragDropManager.setupSolovisRefDrop(this.container, function (solovisRef) {
            if (solovisRef.type == "report") {
                self.setParameterValue(solovisRef.value);
            }
        });
    };


    ReportParameterControl.prototype._setCurrentReportData = function (reportData) {
        this.currentReport = reportData;
        if (this.currentReport) {
            this.selectedReportLabel.text(ReportParameterControl.getLabel(this.currentReport) + " ");
        }
        else {
            this.selectedReportLabel.text("");
        }
    };

    ReportParameterControl.prototype.setParameterValue = function (newValue, more) {        
        Solovis.Reports.Parameters.ParameterControlHelper.handleSetParameterValue(
            this, ReportParameterControl, this._setCurrentReportData, newValue, more);
    };

    ReportParameterControl.prototype.getParameterValue = function () {
        if (this.state < Solovis.UI.BaseControl.ControlState.afterInit) {
            return this.initialParameterValue ? this.initialParameterValue : null;
        }
        else if (this.currentReport) {
            return Solovis.deepCopy(this.currentReport);
        }
        else {
            return null;
        }
    };

    ReportParameterControl.prototype.notifyParameterValueChanged = function () {
        $(this).trigger("parameterValueChanged");
    };   

})();